<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.25" height="14.5" viewBox="0 0 21.25 14.5">
    <g transform="translate(-507.25 -3690.25)">
      <g transform="translate(-302 2832)">
        <g transform="translate(-711 573.93)">
          <path class="a" d="M16,19.357V17.9A2.953,2.953,0,0,0,13,15H7a2.953,2.953,0,0,0-3,2.9v1.452"
                transform="translate(1517 278.714)"/>
          <circle class="a" cx="3" cy="3" r="3" transform="translate(1524.204 285.07)"/>
        </g>
        <g class="b" transform="translate(826.5 870.5) rotate(-90)">
          <path class="c"
                d="M 4.097875118255615 3.5 L 0.9021250009536743 3.5 L 2.5 0.9434000253677368 L 4.097875118255615 3.5 Z"/>
          <path class="d"
                d="M 2.5 1.886800050735474 L 1.804250001907349 3 L 3.195749998092651 3 L 2.5 1.886800050735474 M 2.5 0 L 5 4 L 0 4 L 2.5 0 Z"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "LeadTakerAvatarIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #fff;
  stroke-width: 1.5px;
}

.a, .b {
  stroke-linecap: round;
  stroke-linejoin: round;
}

.b, .d {
  fill: #fff;
}

.c, .d {
  stroke: none;
}
</style>
